import { useNewCode } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { AddMiniIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { historyPush } from 'actions/core/navigation';
import { useBooleanState } from 'hooks/useBooleanState';
import { UserGroupPopup } from '../user_group_popup';
import { createUserGroup } from './slice';
const containerIsPhoneCss = "c1zetjc";
const containerCss = "c1ybdze9";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const NewUserGroupButton = ({
  disabled,
  text,
  decoration
}) => {
  const dispatch = useDispatch();
  const [isOpen, openPopup, closePopup] = useBooleanState(false);
  const useNewEmptyState = useNewCode('activation_q3')?.enabled;
  const handleSuccessGroupCreation = useCallback(userGroup => {
    const editLink = `/app/admin/user_groups/${userGroup.id}/users`;
    dispatch(historyPush(editLink));
  }, [dispatch]);
  const handleSubmit = useCallback(({
    name
  }) => dispatch(createUserGroup({
    name
  }, {
    onSuccess: handleSuccessGroupCreation
  })), [dispatch, handleSuccessGroupCreation]);
  return <Container>
      <Button onClick={openPopup} disabled={disabled} decoration={decoration}>
        {useNewEmptyState && <AddMiniIcon />}
        {text || I18n.t('publisher.organization.user_groups.list.add_new')}
      </Button>
      <UserGroupPopup title={I18n.t('publisher.organization.user_groups.form.title')} confirmLabel={I18n.t('publisher.action.continue')} onSubmit={handleSubmit} onClose={closePopup} isOpen={isOpen} initialValues={{
      name: ''
    }} />
    </Container>;
};

require("./new_user_group_button.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./new_user_group_button.js");